import videojs from 'video.js';

let localize;

export default class PlaycoverPlayButton extends videojs.getComponent('Button') {
    /**
     * 
     * @param {videojs.Player} player
     */
    constructor(player, options) {
        localize = player.localize?.bind(player);
        super(player, options);

        player.ready(() => {
            const playIconWrapper = document.createElement('div');
            videojs.dom.addClass(playIconWrapper, 'mediasite-player__play-cover-play-icon-wrapper');
            playIconWrapper.setAttribute('aria-label', localize('Play Video'));
            this.el().appendChild(playIconWrapper);
            this.controlText(localize('Play Video'));
        });
    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'div';
        props = Object.assign({
            className: 'mediasite-player__playcover-play-button'
        });

        attributes = Object.assign({
            alt: localize('Play Video')
        });

        return super.createEl.call(this, tag, props, attributes);
    }
}